import styled from "styled-components";
import React from "react";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

// type Props = {
//   children: React.ReactNode;
// };
export const AudioContainer = ({ children }) => {
  return <Container>{children}</Container>;
};
